import type { CheckoutForPayment as CheckoutForPaymentResponse } from '@invivodf/module-cart-b2ag-interfaces'
import type { CheckoutForPayment, CustomerContact } from './checkout-for-payment.ts'
import type { CustomerContactDto } from '@b2ag/module-universcoop-sdk'

export const toCheckoutForPayment = (checkoutData: CheckoutForPaymentResponse): CheckoutForPayment => {
  return {
    id: checkoutData.id,
    companyName: checkoutData.companyName,
    hasPhytosanitaryProducts: checkoutData.hasPhytosanitaryProducts,
    lineItemsCount: checkoutData.lineItemsCount,
    organizationId: checkoutData.organizationId,
    prices: {
      totalLineItemsPreDiscounts: checkoutData.prices.totalLineItemsPreDiscounts,
      totalLineItems: checkoutData.prices.totalLineItems,
      totalRpd: checkoutData.prices.totalRpd,
      discounts: checkoutData.prices.discounts.map((discount) => ({
        label: discount.label,
        price: discount.price,
      })),
      totalWithoutTax: checkoutData.prices.totalWithoutTax,
      totalPaymentDueDates: checkoutData.prices.totalPaymentDueDates,
      totalTax: checkoutData.prices.totalTax,
      totalWithTax: checkoutData.prices.totalWithTax,
      totalDeliveryCost: checkoutData.prices.totalDeliveryCost,
    },
    consignments: checkoutData.consignments.map((consignment) => ({
      id: consignment.id,
      delivery: {
        mode: consignment.delivery.mode,
        comment: consignment.delivery.comment,
        address: consignment.delivery.address,
        method: {
          name: consignment.delivery.method.name,
          option: {
            reference: consignment.delivery.method.option.reference,
            addons: consignment.delivery.method.option?.addons.map((addon) => ({
              reference: addon.reference,
            })),
            wishedDeliveryDate: consignment.delivery.method.wishedPeriod
              ? {
                  start: consignment.delivery.method.wishedPeriod.start,
                  end: consignment.delivery.method.wishedPeriod.end,
                }
              : undefined,
          },
        },
      },
      lineItems: consignment.lineItems.map((item) => ({
        imageURL: item.imageURL,
        name: item.name,
        quantity: item.quantity,
        services: item.services.map((service) => ({
          name: service.name,
        })),
        analytics: {
          offerId: item.analytics.offer_id,
          itemName: item.analytics.item_name,
          itemId: item.analytics.item_id,
          itemBrand: item.analytics.item_brand,
          itemCategory: item.analytics.item_category,
          itemVariant: item.analytics.item_variant,
          variantPackaging: item.analytics.variant_packaging,
          price: item.analytics.price,
          quantity: item.analytics.quantity,
        },
      })),
    })),
  }
}

export const toCustomerContacts = (
  contactsData: CustomerContactDto[],
  hasPhytosanitaryProducts: boolean,
): CustomerContact[] => {
  return contactsData
    .filter((contactData) => contactData.canValidateOrder === true)
    .filter((contactData) => {
      if (hasPhytosanitaryProducts) {
        return contactData.certiphytoCurrentValidity === true
      }
      return true
    })
    .map((contactData) => ({
      id: contactData.id,
      firstName: contactData.firstName,
      lastName: contactData.lastName,
      email: contactData.email,
      phoneNumber: contactData.phoneNumber || undefined,
      canValidateOrder: contactData.canValidateOrder,
      certiphytoCurrentValidity: contactData.certiphytoCurrentValidity,
      certiphytoEndDate: contactData.certiphytoEndDate || undefined,
      explosivePrecursorEndDate: contactData.explosivePrecursorEndDate || undefined,
    }))
}
